/**
 * Client-side configuration constants
 */

// Authentication settings
export const AUTH_REDIRECT_URL_KEY = 'auth_redirect_url';
